import { useSidebarPinState, InfoCard } from '@backstage/core-components';
import List from '@material-ui/core/List';
import React from 'react';
import { UserSettingsPinToggle } from './UserSettingsPinToggle.esm.js';
import { UserSettingsThemeToggle } from './UserSettingsThemeToggle.esm.js';
import { UserSettingsLanguageToggle } from './UserSettingsLanguageToggle.esm.js';

const UserSettingsAppearanceCard = () => {
  const { isMobile } = useSidebarPinState();
  return /* @__PURE__ */ React.createElement(InfoCard, { title: "Appearance", variant: "gridItem" }, /* @__PURE__ */ React.createElement(List, { dense: true }, /* @__PURE__ */ React.createElement(UserSettingsThemeToggle, null), /* @__PURE__ */ React.createElement(UserSettingsLanguageToggle, null), !isMobile && /* @__PURE__ */ React.createElement(UserSettingsPinToggle, null)));
};

export { UserSettingsAppearanceCard };
//# sourceMappingURL=UserSettingsAppearanceCard.esm.js.map
